import { Bell, ClipboardList, ShieldCheck, Stethoscope, Store, Users } from 'lucide-react';
import { VERTICAL_COMPARISON } from '../comparisonMatrix';
import type { LandingConfig } from '../types';

export const doctorsConfig: LandingConfig = {
  slug: 'doctors',
  namespace: 'landing-doctors',
  analyticsId: 'for-doctors',
  canonicalPath: '/for-doctors',
  ogImagePath: '/images/og-doctors.jpg',
  heroImage: '/images/hero-doctors',
  // Order matches landing-doctors:features.items[]
  featureIcons: [Store, Stethoscope, Bell, ClipboardList, Users, ShieldCheck],
  comparison: VERTICAL_COMPARISON,
};
